<template>

    <div class="modal__overlay">

        <div class="modal-editHTML">

            <template v-if="props.content.htmlType == 'ENUNCIADO'">
                <div class="header">
                    <h4>{{ props.content.id ? $t('html.EDIT_STATEMENT') : $t('html.CREATE_STATEMENT') }}</h4>
                    <i class="material-icons" @click.stop="emit('close')">close</i>
                </div>
                <div class="select">
                    <Select 
                        v-model="configHTML.type"
                        mode="simple"
                        id="selectHeaderHTML"
                        :label="$t('html.STATEMENT_TYPE')"
                        valueProp="id"
                        valueLabel="name"
                        :values="configHTML.types"
                        :isDropdown="true"
                        @update:modelValue="type => changeHeader(type)"
                    />
                </div>
            </template>

            <div v-show="!hideEditor">
                <TinyMCE 
                    :content="props.content.data.Data"
                    ref="tinyEditor"
                />
            </div>

            <div class="modal__buttons" :style="[hideEditor ? {'padding-top':'82px'} : '']">
                <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="save()" :disabled="hideEditor || saving">{{ $t('global.SAVE') }}</button>
            </div>

        </div>


    </div>

</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import Select from '@/components/Inputs/Select.vue';
import defaultContents from "./defaultContents.js";
import TinyMCE from '@/components/TinyMCE.vue';
import { useI18n } from 'vue-i18n';


const store = useStore();

const props = defineProps({
    content: Object
});
const emit = defineEmits(['close','reload']);

const { t } = useI18n();


const tinyEditor = ref(null);

const hideEditor = ref(false);

const saving = ref(false);

const configHTML = ref({
    type: "",
    types: [
        { id: "bienvenida", name: t('html.WELCOME'), },
        { id: "material-observar", name: t('html.MATERIAL_TO_WATCH'), },
        { id: "material-leer", name: t('html.MATERIAL_TO_READ'), },
        { id: "material-interactuar", name: t('html.MATERIAL_TO_INTERACT'), },
        { id: "fin-modulo", name: t('html.END_OF_MODULE'), },
    ]
})

const changeHeader = type => { 
    tinyEditor.value.editorInstance.setContent( defaultContents.find(cont => cont.id == type).content );
    hideEditor.value = false;
}

const save = async ()=> { 
    saving.value = true;
    let model = props.content;
    model.data.Data = tinyEditor.value.editorInstance.getContent()
    try {
        model.id
            ? await store.dispatch('contentEditor_editContent', model)
            : await store.dispatch('contentEditor_createContent', model);
        emit('reload');        
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: t('html.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}

/*const create = async ()=> {
    let model = {
        courseCfgId: props.content.courseId,
        moduleCfgId: props.content.moduleId, 
        type: 'HTML',
        htmlType: 'ENUNCIADO',
        orderNumber: props.content.orderNumber,
        isMandatory: true,
        data: {
            Data: tinyEditor.value.editorInstance.getContent()
        }
    }
     
    let model = props.content;
    model.data.Data = tinyEditor.value.editorInstance.getContent()

    //console.log(model)
    await store.dispatch('contentEditor_createContent', model);
    emit('reload');
}*/

onMounted(()=>{
    if(!props.content.id) hideEditor.value = true;
})



</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.modal__overlay{
    z-index: 1 !important;
}

.modal-editHTML{
    .header{
        padding-bottom: 6px;
        display: flex;
        justify-content: space-between;
        i{
            cursor: pointer;
        }
    }
    width: 96%;
    max-width: 800px;
    max-height: 80vh;
    padding: 22px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 22px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    h4{
        padding-left: 4px;
    }
    .select{
        max-width: 240px;
    }
    .modal__buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        .cancel{
            border: none;
        }
    }
}


</style>